module.exports = __webpack_public_path__ + "static/divider1.54cd32c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/divider1.jpg
// module id = 179
// module chunks = 35783957827783 162898551421021